export default "__VITE_ASSET__DGy6ahiK__"